import { RouteRecordRaw } from "vue-router";
import { routePrivateProfile } from "@/router/routes/private/RoutePrivateProfile";
import { routePrivateSearch } from "@/router/routes/private/RoutePrivateSearch";
import { routePrivateAdmin } from "@/router/routes/private/RoutePrivateAdmin";
import { routePrivateOffers } from "@/router/routes/private/RoutePrivateOffers";
import { routePrivateOrders } from "@/router/routes/private/RoutePrivateOrders";

export const routesPrivate: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Private",
    component: () => import("@/app/private/Private.vue"),
    children: [
      ...routePrivateSearch,
      ...routePrivateOffers,
      ...routePrivateOrders,
      ...routePrivateProfile,
      ...routePrivateAdmin,
    ],
  },
];
